import { render, staticRenderFns } from "./FeeTables.vue?vue&type=template&id=a11222d4&"
import script from "./FeeTables.vue?vue&type=script&lang=js&"
export * from "./FeeTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports